import { StarbaseEntity } from 'starbase-launcher';
import { Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';

export class RankCategory extends StarbaseEntity implements Serializable<RankCategory> {
    public rankCategory: string;
    public rankCategoryName: string;

    constructor() {
        super();
    }

    public static RankCategoryColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Rank Category', 'rankCategory', 'rankCategory', editable, 'string', true, true, 100, true),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, true, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, true, 20, false)
        ];
    }
    public static CreateRankCategoryColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Rank Category', 'rankCategory', 'rankCategory', true, 'string', false, true, 100, true)
        ];
    }

    deserialize(input) {
        return Object.assign(new RankCategory(), input);
    }
}
